import { DeclinedApplicationState } from '../../Dashboard.types';
import styles from './DeclinedApplication.module.css';
import MainContentPending from '../../../../pageStructure/mainContentPending/MainContentPending';
import { useGetSpendingLimitRequest } from '@api/lendingAPI/lapiHooks';

const DeclinedApplication = ({
    application
}: {
    application?: DeclinedApplicationState;
}) => {
    const redirect_url = application?.payLink.redirect_url;

    const { spendingLimitRequest, loadingSpendingLimitRequest } =
        useGetSpendingLimitRequest();

    if (loadingSpendingLimitRequest) return <MainContentPending />;

    return (
        <div className={styles.declinedContainer}>
            <h2>
                Sorry, we can't approve your{' '}
                {spendingLimitRequest?.uuid
                    ? 'spending limit request'
                    : 'application'}{' '}
                today.
            </h2>
            <p>
                If you’d like to speak to us about the decision or you have any
                questions, give us a ring on{' '}
                <a className={styles.link} href="tel:0203 778 0549">
                    0203 778 0549
                </a>
            </p>
            {redirect_url && (
                <a href={redirect_url} className={styles.redirectButton}>
                    Return to merchant
                </a>
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DeclinedApplication;
